import { render, staticRenderFns } from "./EmploymentStatusForm.vue?vue&type=template&id=cbca589c&"
import script from "./EmploymentStatusForm.vue?vue&type=script&lang=js&"
export * from "./EmploymentStatusForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports